
    export class PaymentCaptureFormControlVariables {
        billingSameAsService = false;
        hasSubmittedPaymentCapture = false;
        paymentResult: string;
        hasError = false;
        submittingPaymentCapture = false;
        responseCode: number = null;
        editPaymentCaptureOnly = false;
        escalatorBackgroundColor = '#E0F3FB';
        customerHasPartnerCustomerNumber = false;
    }
